import * as React from "react";
import Layout from "./layout";
import Seo from "./seo";
import Spacer from "./Spacer";
import thb from "../images/bCover8K.png";
import "../styles/journal.css";

const Blog = ({ data, location, pageContext }) => {
  /*const projects = data.allPrismicBlog.nodes;
  console.log(pageContext.pageNumber);
  const url = location.href ? location.href : "";
  let arrs = url.split("/");
  //Filter array, remove blank strings
  let arr = arrs.filter((elm) => elm);
  let str = arr[arr.length - 1];

  let goBacktick = str === "journal" ? false : true;
  console.log("Backtick: " + goBacktick);*/

  // console.log("PROJECTS");
  // console.log(projects);
  // const url1 = data.allPrismicBlogpage
  // console.log(` URL1 = ${url1} `)
  // console.log(url1)
  // console.log("  prooject 2" + projects[2])

  //  const [selectedOption, setSelectedOption] = useState("All");
  /*
  let tagsarr = [];
  projects.map((item) => item.tags.map((item2) => tagsarr.push(item2)));
  tagsarr = removeDuplicates(tagsarr);
  // console.log("tagarrr  :" + tagsarr)

  function removeDuplicates(arr) {
    return arr.filter((item, index) => arr.indexOf(item) === index);
  }
*/
  console.log(pageContext.content);
  function randomProperty(list) {
    return list[Math.floor(Math.random() * list.length)];
  }
  const elementoption = (sld, sld2) => (sld ? sld2 : "");
  const linkstouse = [
    "https://asteriasoft.studio/",
    "https://asteriasoft.studio/about/",
    "https://asteriasoft.studio/website/",
    "https://asteriasoft.studio/website-ny/",
    "https://asteriasoft.studio/website-ca/",
    "https://www.persimmon.design/",
  ];
  return (
    <Layout pageTitle="Blog">
      <div className="mainpage blogpage">
        {/*<div className="journalgrid1">
          <h1 className="header1">Ideas are forever.</h1>
          <StaticImage
            alt="journal page dome"
            src="../images/home/j1.png"
            className="image"
          />
          <p className="header4">
            Architecture, Interiors, Websites - explore design as centre of all.
          </p>
  </div>*/}

        <Spacer classes="h30" />

        <div className="blogsection">
          <div className="header">
            <div className="headerslice">
              <h2>{pageContext.title}</h2>
            </div>
          </div>
          <div className="text">
            {pageContext.content.map((item, index) => (
              <article key={index * 2 + index} className="textslice">
                <p>{item}</p>
              </article>
            ))}
            <article className="textslice">
              <a href={linkstouse[pageContext.linkindex]}>
                {pageContext.linktext}
              </a>
            </article>
            <Spacer classes="h1" />
            <article className="textslice">
              {elementoption(
                pageContext.persimmonlink,
                <a href={linkstouse[5]}>{"Seattle Interior Designer"}</a>
              )}{" "}
            </article>
          </div>
        </div>
        <Spacer classes="h30" />
      </div>

      <Spacer classes="h10"></Spacer>

      <Spacer classes="h10"></Spacer>
    </Layout>
  );
};

export const Head = ({ pageContext }) => (
  <Seo
    title={pageContext.title}
    image={thb}
    description={`Dive into the world of design with our captivating ${pageContext.pagetitle} ${pageContext.pageNumber}.`}
    article={true}
    datePublished="2024-01-08T13:12:45Z"
    dateModified="2024-01-08T13:12:45Z"
  />
);
export default Blog;
